import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListEmspUserEmailAddressCell } from './emsp-bo-rfid-badge-order-list-emsp-user-email-address.cell';
import { EmspBoRfidBadgeOrderListEmspUserEmailAddressHeader } from './emsp-bo-rfid-badge-order-list-emsp-user-email-address.header';

export const EmspBoRfidBadgeOrderListEmspUserEmailAddressColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['emspUser']['emailAddress']
> = {
  id: 'emspUserEmailAddress',
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListEmspUserEmailAddressHeader,
  cell: EmspBoRfidBadgeOrderListEmspUserEmailAddressCell,
};
